module.exports = __webpack_public_path__ + "static/media/grizzhacks.c4a79cd7.jpg";